import React, { Component } from 'react'
import ReactPlayer from 'react-player'
import styled from "styled-components";

const PlayerWrapper = styled.div`
  position: relative;
  padding-top: 56.25%; /* Player ratio: 100 / (1280 / 720) */
   
  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

function VideoPlayer(props) {
    return (
      <PlayerWrapper>
        <ReactPlayer
          url={props.url}
          width={'100%'}
          height={'100%'}
          className={'react-player'}
          playing={props.playing}
          controls={true}
        />
      </PlayerWrapper>
    )
}

export default VideoPlayer
